import {useEffect} from 'react'

import {getBuildLocator} from '../../../../rest/locators'
import {restApi} from '../../../../services/rest'
import type {BuildId} from '../../../../types'
import {subscribeOnOverallEvents} from '../../../../utils/subscriber'
import {BUILD_QUEUE_ORDER_CHANGED} from '../../../../utils/subscriptionEvents'

export function useQueueBuildUpdater(buildId: BuildId) {
  const [refetch] = restApi.endpoints.getBuildNormalized.useLazyQuerySubscription()

  useEffect(
    () =>
      subscribeOnOverallEvents([`events/${BUILD_QUEUE_ORDER_CHANGED};`], () => {
        refetch({
          buildLocator: getBuildLocator(buildId),
          fields: 'id,state,queuePosition',
        })
      }),
    [buildId, refetch],
  )
}
